"use client";

import { Button, Divider, Icon, Text } from "@stone-payments/jade";
import { cn } from "@/utils/classnames";
import { Mask } from "@/utils/masks";

type Props = {
  open: boolean;
  quantity: number;
  price: number;
  onOpenCart: () => void;
};

export const FloatingCartBar = ({
  open,
  quantity,
  price,
  onOpenCart,
}: Props) => {
  return (
    <div
      className={cn(
        "fixed right-[10px] bottom-0 left-[10px] m-auto w-[calc(100%-20px)] max-w-[388px] transition-all duration-300 z-60",
        {
          "bottom-[10px]": open,
          "-bottom-64": !open,
        }
      )}
    >
      <div className="rounded-[10px] bg-jade-background-brand-high p-jade-200">
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-jade-100">
            <Icon use="cart" color="on-brand-high" size="large" />

            <div className="flex flex-col-reverse sm:flex-row sm:items-center sm:gap-jade-200">
              <Text color="on-brand-high" variant="text-medium">
                {quantity} {quantity === 1 ? "item" : "itens"}
              </Text>

              <div className="hidden h-[24px] sm:block">
                <Divider direction="vertical" size="small" />
              </div>

              <Text color="on-brand-high" variant="text-medium" weight="medium">
                {Mask.formatToBrlCurrency(price)}
              </Text>
            </div>

            <div className="block h-[24px] sm:hidden">
              <Divider direction="vertical" size="small" />
            </div>
          </div>

          <Button variant="on-brand-subtle" size="small" onClick={onOpenCart}>
            Ir pro carrinho
          </Button>
        </div>
      </div>
    </div>
  );
};
